import { render, staticRenderFns } from "./ThanksValidate.vue?vue&type=template&id=6f7b0d7a&"
import script from "./ThanksValidate.vue?vue&type=script&lang=js&"
export * from "./ThanksValidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports